/**
 * WordPress dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Save function
 */
export default function save() {
	// Block Props
	useBlockProps.save();

	return null;
}
